/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';

import {PropertyType} from '../models/property-type';
import {PropertyTypeParameter, DEFAULT_PARAMETER, BOOLEAN_PARAMETERS, STRING_PARAMETERS, COLOR_PARAMETERS, INTEGER_PARAMETERS} from '../models/property-type-parameter';

@Injectable()
export class PropertyTypeService {

  constructor(
  ) {}

  getParametersForPropertyType(propertyType: PropertyType): PropertyTypeParameter[] {
    const rv: PropertyTypeParameter[] = [];

    //Add the "null" option
    rv.push(DEFAULT_PARAMETER);

    //Depending on the Property Type, add other possible values
    if (propertyType != null) {
      switch (propertyType) {
        case PropertyType.BOOLEAN: {
          BOOLEAN_PARAMETERS.forEach(param => rv.push(param));
          break;
        }
        case PropertyType.STRING: {
          STRING_PARAMETERS.forEach(param => rv.push(param));
          break;
        }
        case PropertyType.COLOR: {
          COLOR_PARAMETERS.forEach(param => rv.push(param));
          break;
        }
        case PropertyType.INTEGER: {
          INTEGER_PARAMETERS.forEach(param => rv.push(param));
          break;
        }
      }
    }

    return rv;
  }


  getDisplayValueForPropertyType(propertyType: PropertyType): string {
    switch (propertyType) {
      case PropertyType.BOOLEAN:
        return "BOOLEAN";
      case PropertyType.CHARACTER:
        return "SINGLE LETTER";
      case PropertyType.COLOR:
        return "COLOR";
      case PropertyType.INTEGER:
        return "NUMBER";
      case PropertyType.POINT:
        return "POINT";
      case PropertyType.STRING:
        return "STRING";
      case PropertyType.SERVEROBJECT_REFERENCE:
        return "SERVER OBJECT";
      case PropertyType.OBJECT_REFERENCE:
        return "DEVICE/ASSET";
      case PropertyType.DRIVEROBJECT_REFERENCE:
        return "DRIVER";
      case PropertyType.SERVICE_REFERENCE:
        return "SERVICE";
      case PropertyType.LOCATION_REFERENCE:
        return "LOCATION";
      case PropertyType.ZONE_REFERENCE:
        return "ZONE";
      case PropertyType.TAG_REFERENCE:
        return "TAG";
      case PropertyType.READER_REFERENCE:
        return "READER";
      case PropertyType.ANTENNA_REFERENCE:
        return "ANTENNA";
      case PropertyType.USER_REFERENCE:
        return "USER";
      case PropertyType.IMAGE_REFERENCE:
        return "IMAGE";
      case PropertyType.TIMESTAMP:
        return "TIMESTAMP";
	  case PropertyType.OBJECTTYPE_REFERENCE:
		return "OBJECT TYPE";
      default:
        return propertyType;
    }
  }

}
